import { sendGTMEvent } from '@next/third-parties/google'
import type { GtmGlobalStoreProps } from '../../useGTM'
import { getEcommerceObjectFromCart } from '../../helpers/getEcommerceObjectFromCart'
import { gtmClearEcommerceData } from '../../helpers/clearEcommerceData'

export type GtmPurchaseCompleteType = {
  transaction_id: string
  payment_method: string
  shipping_method: string
  shipping_country: string
  shipping_state: string
  shipping_city: string
  items_count: number
  shipping_total: number
  tax_total: number
  subtotal: number
  order_number: string
  subscription_discount: number
  order_total: number
  has_previously_purchased: boolean
  purchase_type: 'order' | 'subscription'
}

export const gtmPurchaseComplete = ({
  transaction_id,
  globalStore,
  payment_method,
  shipping_method,
  shipping_country,
  shipping_state,
  shipping_city,
  items_count,
  shipping_total,
  tax_total,
  subtotal,
  order_number,
  subscription_discount,
  order_total,
  has_previously_purchased,
  purchase_type,
}: GtmGlobalStoreProps & GtmPurchaseCompleteType) => {
  const uuid = crypto.randomUUID()

  gtmClearEcommerceData()

  sendGTMEvent({
    event: 'purchase',
    event_id: uuid,
    order_number,
    subscription_discount,
    payment_method,
    shipping_method,
    shipping_country,
    shipping_state,
    shipping_city,
    items_count,
    has_previously_purchased,
    purchase_type,
    ecommerce: {
      shipping: shipping_total,
      tax: tax_total,
      transaction_id,
      subtotal,
      order_total,
      ...getEcommerceObjectFromCart({
        globalStore,
        cart: [...globalStore.cart.otp, ...globalStore.cart.subscribe],
      }),
    },
  })
}
